import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "008_add_capability_primary",
  version: "0.8.0",
  sql: `
ALTER TABLE \`connectors_instances\` ADD COLUMN \`capability_primary\` text;
UPDATE \`connectors_instances\`
  SET \`capability_primary\` = (
    SELECT json_extract(t.capabilities, '$[0]')
    FROM \`connectors_types\` t
    WHERE t.id = \`connectors_instances\`.\`type_id\`
  )
  WHERE \`capability_primary\` IS NULL;
CREATE INDEX IF NOT EXISTS \`connectors_instances_company_capability_status_idx\`
  ON \`connectors_instances\` (\`company_id\`, \`capability_primary\`, \`status\`);
`,
};
